export default __webpack_public_path__ + "static/media/Merriweather-Regular.365511c5.woff";